enum WorkspaceProjectAiChatVectorStorage {
  qdrant = 'qdrant',
  pgvector = 'pgvector',
}

export default WorkspaceProjectAiChatVectorStorage
